import type { SxProps, Theme } from "@mui/material/styles";
import type { Props as SimplebarProps } from "simplebar-react";

import { Box } from "@mui/material";
import { forwardRef } from "react";
import SimpleBar from "simplebar-react";

export type ScrollbarProps = SimplebarProps & {
  children?: React.ReactNode;
  fillContent?: boolean;
  slotProps?: {
    content?: Partial<SxProps<Theme>>;
    contentWrapper?: SxProps<Theme>;
    wrapper?: SxProps<Theme>;
  };
  sx?: SxProps<Theme>;
};

const scrollbarClasses = { root: "mnl__scrollbar__root" };

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  function Scrollbar({ children, fillContent, slotProps, sx, ...other }, ref) {
    return (
      <Box
        className={scrollbarClasses.root}
        clickOnTrack={false}
        component={SimpleBar}
        scrollableNodeProps={{ ref }}
        sx={{
          "& .simplebar-content": {
            ...(fillContent && {
              display: "flex",
              flex: "1 1 auto",
              flexDirection: "column",
              minHeight: 1,
            }),
            ...slotProps?.content,
          } as React.CSSProperties,
          "& .simplebar-content-wrapper":
            slotProps?.contentWrapper as React.CSSProperties,
          "& .simplebar-wrapper": slotProps?.wrapper as React.CSSProperties,
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minHeight: 0,
          minWidth: 0,
          ...sx,
        }}
        {...other}
      >
        {children}
      </Box>
    );
  },
);
